<script>
import { createEventDispatcher } from "svelte";
import Calendario from "./Calendario.svelte";
import {clickOutside} from './clickOutside.js';

export let editField;
export let objectSource;

let mostrarCalendario = false;
let posicaoClique = {x: 0, y: 0};
let strData;
let valorAnterior;
const dispatch = createEventDispatcher();

function changeData() {
  if (strData && strData.trim().length == 8 || strData.trim().length == 10) {  
    try {          
      let dt;
      let ano;
      let mes;
      let dia;
      if (strData.trim().length == 8) {
        ano = Number(strData.substring(4, 8));
        mes = Number(strData.substring(2, 4)) - 1;
        dia = Number(strData.substring(0, 2));
      } else if (strData.trim().length == 10) {
        ano = Number(strData.substring(6, 10));
        mes = Number(strData.substring(3, 5)) - 1;
        dia = Number(strData.substring(0, 2));
      }                  
      if (isNaN(dia)) dia = 0;
      if (isNaN(mes)) mes = 0;
      if (isNaN(ano)) ano = 0;
      mes += 1;
      strData = (dia < 10 ? '0'+dia : dia) + '/' + (mes < 10 ? '0'+mes : mes) + '/' + (ano);      
      if (!validarData(dia, mes, ano)) {
        strData = null;
      }      
    } catch (error) {
      strData = null;      
    }
  } else {
    strData = null;
  }
  setObjectSource();
  dispatch('change', strData); 
}

function validarData(day, month, uear) {
  if (month < 1 || month > 12) { // check month range
    return false;
  }
  if (day < 1 || day > 31) {
    return false;
  }
  if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
    return false;
  }
  if (month == 2) { // check for february 29th
    var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
    if (day > 29 || (day == 29 && !isleap)) {
      return false;
    }
  }
  return true;
}

function setObjectSource() {
  if (objectSource && editField) {
    if (strData) {
      objectSource[editField] = strData;
    } else {
      objectSource[editField] = null;
    }
  }
}

$: if (objectSource && editField) {
  if (objectSource[editField] && objectSource[editField] != valorAnterior) {     
    valorAnterior = objectSource[editField];      
    if (strData) {
      if (strData != objectSource[editField]) {
        strData = objectSource[editField];
      }
    } else {
      strData = objectSource[editField];
    }
  } else {      
    if (objectSource[editField] != valorAnterior) {
      strData = null;
      valorAnterior = null;
    }
  }
}

function clickCalendario(event) {
  // console.log(event.clientX, event.clientY, outerWidth, innerWidth, innerHeight, outerHeight);  
  posicaoClique.x = event.clientX;
  posicaoClique.y = event.clientY;
  mostrarCalendario = !mostrarCalendario;  
}

function changeDataCalendario(event) {      
  strData = event.detail.data;
  mostrarCalendario = false;  
  setObjectSource();
  dispatch('change', strData); 
}

function clickForaDoCalendario() {  
  mostrarCalendario = false;
}

  $: outerWidth = 0
  $: innerWidth = 0
	$: outerHeight = 0
	$: innerHeight = 0

  function handleClickOutside(event) {
    console.log('clicou fora date picker');
    dispatch('clicouFora');
    mostrarCalendario = false;
  }

</script>

<svelte:window bind:innerWidth bind:outerWidth bind:innerHeight bind:outerHeight/>

<div style="position: relative; width: fit-content;">
  <div class="hgroup" style="position: relative; align-items: center; padding: 0 3px; border: 1px solid #d3d3d3; border-radius: 3px;" on:click={clickCalendario}>    
    <div style="padding: 5px; text-align: center;">{strData}</div>
    <button><i class="far fa-calendar"></i></button>
  </div>
  {#if mostrarCalendario}
    <div style="position: fixed; top: {innerHeight-posicaoClique.y < 300 ? posicaoClique.y - 300 + 'px' : posicaoClique.y + 'px'}; left: {innerWidth-posicaoClique.x < 300 ? posicaoClique.x - 300 + 'px' : posicaoClique.x + 'px'}; z-index: 1000000000; width: 300px;">
      <Calendario on:change={(e) => changeDataCalendario(e)} 
        bind:dataSelecionada={strData} 
        on:clicouFora={clickForaDoCalendario}/>
    </div>    
  {/if}
</div>


<style>
  /* .hgroup {
    display: flex;
    flex-direction: row;
    width: fit-content;
    align-items: stretch;
  } */
  /* .btnDate {
    position: absolute;
    top: 2px;
    bottom: 2px;    
    right: 2px;
    border: none;
  } */
  /* input {
    text-align: center; 
    margin: 0;
  } */
  .hgroup {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  button {
    margin: 0; 
    margin-left: -1px;
  }
</style>

<svelte:options tag="svelte-datepicker" />